














import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import { Project, ProjectEvent } from "../../model/project";
import ProjectCardCarousel from "../project-card-carousel/project-card-carousel.vue";
import Vote from "../vote/vote.vue";
import { dataService } from "../../services/data/data-service";
import "./project.less";
import { getVotingEnabledData } from "../../services/getProjectData/getProjectData";
import BadgesComponent from "../badges/badges.vue";

@Component({
  components: {
    Vote,
    ProjectCardCarousel,
    BadgesComponent
  }
})
export default class ProjectComponent extends Vue {
  @Prop() year!: string;
  @Prop() project!: Project | null;
  @Prop() fadeVoted;

  private subscription;
  private ranking: string | null = null;
  private voting_enabled = 0;

  async mounted() {
    this.voting_enabled = getVotingEnabledData();
    this.subscription = dataService.categoryData.data.subscribe(
      (ev: ProjectEvent) => {
        if (ev.event == "voteSuccess" && ev.data.id == this.project!.id) {
          this.ranking = ev.data.vote;
        }
        if (ev.event == "fetch") {
          this.ranking = dataService.getVote(this.project!.id);
        }
      }
    );
    await this.$nextTick();
    this.ranking = dataService.getVote(this.project!.id);
  }

  beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  trans(key) {
    return translate(key);
  }

  navigate(url) {
    location.href = url;
  }

  getBadgesData() {
    return {
      nominee: this.project!.life_challenge_nominee,
      winner: this.project!.life_challenge_winner,
      total_winner: this.project!.life_challenge_total_winner,
      public_winner: this.project!.life_challenge_public_winner
    };
  }

  getProjImages() {
    if (this.project!.images) {
      return [...this.project!.images!].sort(
        (im1, im2) => im2.is_cover - im1.is_cover
      );
    }
    return [];
  }
}
